(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tights-swatches"] && !window.DesignMode) return;
  try {
    
  function initTightsSwatches() {
    const sections = document.querySelectorAll('.tights-swatches-section');
    
    sections.forEach(function(section) {
      const swatches = section.querySelectorAll('.swatch-item');
      const defaultImage = section.querySelector('.default-image');
      const hoverImages = section.querySelectorAll('.hover-image');
      
      swatches.forEach(function(swatch, swatchIndex) {
        const hoverImage = hoverImages[swatchIndex];
        
        swatch.addEventListener('mouseenter', function() {
          if (hoverImage && defaultImage) {
            defaultImage.style.opacity = '0';
            hoverImage.style.opacity = '1';
          }
        });
        
        swatch.addEventListener('mouseleave', function() {
          if (defaultImage) {
            defaultImage.style.opacity = '1';
          }
          
          hoverImages.forEach(function(img) {
            img.style.opacity = '0';
          });
        });
      });
    });
  }

  function initAnimations() {
    const sections = document.querySelectorAll('.tights-swatches-section');
    
    sections.forEach(function(section) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            section.classList.add('animate');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.5,
        rootMargin: '0px 0px -100px 0px'
      });
      
      observer.observe(section);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initTightsSwatches();
      initAnimations();
    });
  } else {
    initTightsSwatches();
    initAnimations();
  }
  
  // Backup initialization on window load
  window.addEventListener('load', function() {
    initTightsSwatches();
    initAnimations();
  });

  } catch(e) { console.error(e); }
})();
})();
